import { Box } from '@mui/material'

interface TaRagExpandableProps {
  question: any
  editable?: boolean
  minitags?: boolean
}

function stateColor(state: string | undefined): string {
  if (state === 'red') return 'rgba(220,20,60,0.85)'
  if (state === 'amber') return 'rgba(255,140,0,0.85)'
  if (state === 'green') return 'rgba(46,139,87,0.85)'
  return 'transparent'
}

function minitagColor(val: number | undefined | null): string {
  if (val === undefined || val === null) return 'rgba(180,180,180,0.5)'
  if (val < 33) return 'rgba(220,20,60,0.7)'
  if (val < 66) return 'rgba(255,140,0,0.7)'
  return 'rgba(46,139,87,0.7)'
}

export default function TaRagExpandable({ question, minitags }: TaRagExpandableProps) {
  const displayLabel = question?.numbering ?? ((question?.index ?? 0) + 1)

  return (
    <Box
      title={question?.numbering}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 22,
        height: 22,
        borderRadius: 1,
        bgcolor: stateColor(question?.state),
        border: 1,
        borderColor: 'divider',
        px: 0.5,
        fontSize: '0.7rem',
        fontWeight: 600,
        userSelect: 'none',
        flexShrink: 0,
        gap: 0.25,
      }}
    >
      <Box component="span">{displayLabel}</Box>
      {minitags && (
        <>
          <Box sx={{ width: 5, height: 5, borderRadius: '50%', bgcolor: minitagColor(question?.answerobj?.simint), ml: 0.25 }} />
          <Box sx={{ width: 5, height: 5, borderRadius: '50%', bgcolor: minitagColor(question?.bideval?.scoreint) }} />
        </>
      )}
    </Box>
  )
}
